/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { DropFollowerEntry } from './DropFollowerEntry';
import {
    DropFollowerEntryFromJSON,
    DropFollowerEntryFromJSONTyped,
    DropFollowerEntryToJSON,
    DropFollowerEntryToJSONTyped,
} from './DropFollowerEntry';

/**
 * 
 * @export
 * @interface PaginatedDropFollowersResponse
 */
export interface PaginatedDropFollowersResponse {
    /**
     * 
     * @type {Array<DropFollowerEntry>}
     * @memberof PaginatedDropFollowersResponse
     */
    followers: Array<DropFollowerEntry>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedDropFollowersResponse
     */
    totalFollowers: number;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedDropFollowersResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the PaginatedDropFollowersResponse interface.
 */
export function instanceOfPaginatedDropFollowersResponse(value: object): value is PaginatedDropFollowersResponse {
    if (!('followers' in value) || value['followers'] === undefined) return false;
    if (!('totalFollowers' in value) || value['totalFollowers'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function PaginatedDropFollowersResponseFromJSON(json: any): PaginatedDropFollowersResponse {
    return PaginatedDropFollowersResponseFromJSONTyped(json, false);
}

export function PaginatedDropFollowersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDropFollowersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'followers': ((json['followers'] as Array<any>).map(DropFollowerEntryFromJSON)),
        'totalFollowers': json['totalFollowers'],
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function PaginatedDropFollowersResponseToJSON(json: any): PaginatedDropFollowersResponse {
    return PaginatedDropFollowersResponseToJSONTyped(json, false);
}

export function PaginatedDropFollowersResponseToJSONTyped(value?: PaginatedDropFollowersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'followers': ((value['followers'] as Array<any>).map(DropFollowerEntryToJSON)),
        'totalFollowers': value['totalFollowers'],
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

